import { createLoadableList } from 'external/immutability-helper'
import create, {initializeAndRegisterHooks} from 'context/create' 
import triggers, * as resolves from './triggers'

const id = 'Public'

export const initialState = {
    offers: createLoadableList(),
    courseDetails: {},
    offersData: {}
}

const context = create(id, initialState, {onInit: initializeAndRegisterHooks(id, triggers, resolves)})
export {context as default}